import { Routes, Route } from "react-router-dom";
import AppLayout from "@/components/layout/AppLayout";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import LoginPage from "@/pages/LoginPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import DashboardPage from "@/pages/DashboardPage";
import DossiersListPage from "@/pages/DossiersListPage";
import DossierCreatePage from "@/pages/DossierCreatePage";
import DossierDetailPage from "@/pages/DossierDetailPage";
import ExpertiseFormPage from "@/pages/ExpertiseFormPage";
import ClientsListPage from "@/pages/ClientsListPage";
import ClientFormPage from "@/pages/ClientFormPage";
import MediasPage from "@/pages/MediasPage";
import ProfilePage from "@/pages/ProfilePage";
import AdminRoute from "@/components/auth/AdminRoute";
import UsersListPage from "@/pages/admin/UsersListPage";
import UserFormPage from "@/pages/admin/UserFormPage";
import DossiersAdminPage from "@/pages/admin/DossiersAdminPage";
import AuditLogsPage from "@/pages/admin/AuditLogsPage";
import NotFoundPage from "@/pages/NotFoundPage";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="dossiers" element={<DossiersListPage />} />
          <Route path="dossiers/nouveau" element={<DossierCreatePage />} />
          <Route path="dossiers/:id" element={<DossierDetailPage />} />
          <Route path="dossiers/:id/expertise" element={<ExpertiseFormPage />} />
          <Route path="dossiers/:id/medias" element={<MediasPage />} />
          <Route path="clients" element={<ClientsListPage />} />
          <Route path="clients/new" element={<ClientFormPage />} />
          <Route path="clients/:id/edit" element={<ClientFormPage />} />
          <Route path="profil" element={<ProfilePage />} />

          {/* Admin */}
          <Route element={<AdminRoute />}>
            <Route path="admin/utilisateurs" element={<UsersListPage />} />
            <Route path="admin/utilisateurs/nouveau" element={<UserFormPage />} />
            <Route path="admin/utilisateurs/:id/modifier" element={<UserFormPage />} />
            <Route path="admin/dossiers" element={<DossiersAdminPage />} />
            <Route path="admin/audit" element={<AuditLogsPage />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
